export default "__VITE_ASSET__CNM5BBwx__"